import React, { Component } from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';

import config from './../config.js';
import reducers from './common/reducers';
import RootContainer from './root/view/root-container';
import { initBrowserHistoryEvents } from './common/browser-history.js';
import { SetCurrentLanguage } from './common/translator.js';

const store = applyMiddleware(thunk)(createStore)(reducers);
initBrowserHistoryEvents(store.dispatch);

class AssetGuide extends Component{
  render() {
    return (
      <div>
        <Provider store={store}>
          <RootContainer/>
        </Provider>
      </div>
     );
  }
}

export default AssetGuide;




/** WEBPACK FOOTER **
 ** app/components/vf-ag-next.js
 **/